export function getArea (state) {
  return state.area
}
export function getSeats (state) {
  console.log(state.seats)
  return state.seats
}
export function getBookingSelected (state) {
  return state.selected
}



// WEBPACK FOOTER //
// ./src/vuex/booking/getters.js